<template>
  <div>
    <div>
      <el-form label-width="110px" :model="formLabelAlign">
        <el-form-item label="接受用戶列表">
          <template>
            <el-table
              :data="tableData"
              border
              empty-text="暫無記錄"
              max-height="500"
              style="width: 70%"
            >
              <el-table-column
                prop="regionName"
                label="分公司"
              ></el-table-column>
              <el-table-column
                prop="branchName"
                label="部門/物業"
              ></el-table-column>
              <!-- <el-table-column
                prop="departmentName"
                label="用戶組別"
              ></el-table-column> -->
              <el-table-column
                prop="positionName"
                label="職位"
              ></el-table-column>
              <el-table-column label="操作" width="100px">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="danger"
                    @click="del(scope.$index)"
                    >禁用</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </template>
          <el-button
            style="margin-top: 20px"
            type="primary"
            @click="dialogActive"
            >選擇接收用戶</el-button
          >
        </el-form-item>
        <el-form-item label="標題">
          <el-input v-model="formLabelAlign.title"></el-input>
        </el-form-item>
        <el-form-item prop="endTime"
                      label="移除日期">
          <el-date-picker :picker-options="pickerOptions"
                          type="datetime"
                          v-model="formLabelAlign.endTime"
                          placeholder="選擇時間"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          style="width: 300px"></el-date-picker>
        </el-form-item>
        <el-form-item label="圖片">
          <el-upload
            class="upload-demo"
            action=""
            accept=".jpg,.png,.gif"
            :on-remove="handleRemove"
            :file-list="fileList"
            :auto-upload="false"
            list-type="picture-card"
            :on-change="changeFile"
            :limit="1"
            :on-exceed="exceed"
          >
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip" style="color: #ff0000">
              建議圖片尺寸：1130px (闊)
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="內容">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入内容"
            v-model="formLabelAlign.content"
            style="width: 400px"
          ></el-input>
        </el-form-item>
      </el-form>

      <!-- 新增的彈窗 -->
      <el-dialog title="新增用户" :visible.sync="dialogVisible" width="500px">
        <el-form label-width="70px">
          <el-form-item label="選擇用戶" style="margin-top: -6px">
            <el-tree
              accordion
              :data="datas"
              :props="defaultProps"
              node-key="code"
              ref="tree"
              show-checkbox
            ></el-tree>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addUser">確 定</el-button>
        </span>
      </el-dialog>

      <div class="dialog-footer">
        <el-button @click="$router.back(-1)">取 消</el-button>
        <el-button type="primary" @click="addMessage">發 佈</el-button>
      </div>
      <el-button class="back" @click="$router.back(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
var that;
export default {
  data() {
    return {
      formLabelAlign: {
        title: "",
        content: "",
      },
      value: [],
      tableData: [],
      fileList: [],
      props: {
        label: "name",
        children: "id",
      },
      count: 1,
      dialogVisible: false,
      datas: [],
      defaultProps: {
        children: "allList",
        label: "name",
      },
      userId: [],
    };
  },
  mounted() {
    $("#pageHead").text("新增通知");
  },
  methods: {
    del(index) {
      this.$confirm("確認禁用？", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "確定",
        type: "warning",
      })
        .then(() => {
          this.tableData.splice(index, 1);
          this.$message({
            type: "success",
            message: "禁用成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消禁用",
          });
        });
    },
    handleRemove(file, fileList) {
      //文件刪除
      this.fileList = fileList;
    },
    exceed() {
      this.$message({
        type: "warning",
        message: "圖片只能上傳一張!",
      });
    },
    changeFile(file, fileList) {
      var audit = this.utils.detectionImageSizeType(file);
      console.log(audit);
      if (audit) {
        this.fileList.push(file);
      } else {
        fileList.pop();
      }
    },
    addUser() {
      var tree = this.$refs.tree;
      var userIdArr = [];
      var arr = tree.getCheckedKeys(); //獲取選擇的id
      arr.filter(function (val) {
        if (val) {
          userIdArr.push(val);
        }
      });

      if (userIdArr.length == 0) {
        this.$message({
          type: "warning",
          message: "請選擇接收用戶!",
        });
        return;
      }
      var positionCodes = userIdArr.toString()// eslint-disable-line no-unused-vars
      this.axios({
        url: "/common/initialize/getReceiveTerUserList",
        method: "Post",
        data: {
          positionCodes: userIdArr.toString(),
        },
      }).then(function (res) {
        if (res) {
          // that.tableData.push.apply(that.tableData, res.result);
          that.tableData = res.result
        }
      });
      this.dialogVisible = false;
    },
    addMessage() {
      let form = this.formLabelAlign;
      let table = this.tableData;
      let formData = new FormData();
      if (form.title == "") {
        this.$message({
          type: "warning",
          message: "請輸入標題!",
        });
        return;
      }
      formData.append("title", form.title);
      if (form.content == "") {
        this.$message({
          type: "warning",
          message: "請填寫內容!",
        });
        return;
      }
      formData.append("content", form.content);
      if (table.length == 0) {
        this.$message({
          type: "warning",
          message: "請選擇接收的用戶!",
        });
        return;
      }
      if (!form.endTime) {
        this.$message({
          type: 'warning',
          message: '請填寫移除日期'
        })
        return
      }
      formData.append('endTime', form.endTime)

      let addPositionCode = [];
      for (let i = 0; i < table.length; i++) {
        addPositionCode.push(table[i].code);
      }
      formData.append("addPositionCode", addPositionCode.toString());
      if (this.fileList.length == 0) {
        this.$message({
          type: "warning",
          message: "請上傳圖片!",
        });
        return;
      }
      formData.append("file", this.fileList[0].raw);
      this.axios
        .post("/manage/addTerMessage", formData, {
          headers: { "content-type": "multipart/form-data" },
        })
        .then(function (res) {
          if (res) {
            that.$message({
              type: "success",
              message: "新增成功!",
            });
            table = [];
            setTimeout(function () {
              that.$router.go(-1);
            }, 1000);
          }
        });
    },
    dialogActive: function () {
      var keys = this.tableData.map(node => node.code)
      if (this.$refs.tree) {
        this.$refs.tree.setCheckedKeys([])
        this.$refs.tree.setCheckedKeys(keys, true)
      }      
      this.$nextTick(() => {
        this.dialogVisible = true
      })
    }
  },
  created() {
    that = this;
    this.axios({
      url: "/common/initialize/getRelevanceList",
    }).then(function (res) {
      if (res) {
        var msg = res.result;
        var arr = [{ allList: msg, name: "全部" }];
        that.datas = arr;
      }
    });
  },
};
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: space-around;
  width: 400px;
  margin: auto;
}
.back {
  position: absolute;
  top: 90px;
  right: 45px;
}
</style>
